module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    ref: "slProveedores",
    staticClass: "form-control",
    attrs: {
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("Seleccione un proveedor")]), _vm._v(" "), _vm._l((_vm.proveedores), function(proveedor) {
    return _c('option', {
      key: proveedor._id,
      domProps: {
        "value": proveedor._id
      }
    }, [_vm._v(_vm._s(proveedor.razonSocial))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4f8d180"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/ComboProveedores.vue
// module id = 1166
// module chunks = 5